import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';


@Component({
  selector: 'app-workers-adp',
  templateUrl: './workers-adp.component.html',
  styleUrls: ['./workers-adp.component.scss']
})
export class WorkersAdpComponent implements OnInit {

  users : any;
  original_users: any;
  search = "";
  page = 1;
  loading = true;

  show_consent = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService:OkAloneService, private transloco: TranslocoService) { }


  ngOnInit(): void {

    this.checkAccess();

  }


  checkAccess(){
    this.loading = true;

    this.okService.get("adp/api-access",{page:this.page})
    .subscribe((data:any) => {

      let access = data.body['access'];

      if(access){
        this.getUsers();
      }else{
        this.loading = false;
        this.show_consent = true;
      }


    });

  }

  getUsers(){
    this.loading = true;

    this.okService.get("adp/workers",{page:this.page})
    .subscribe((data) => {

      this.users = data.body;

      this.loading = false;

    });

  }

  importWorker(user:any){
    //console.log(user);

    this.okService.post("workers",user)
    .subscribe((data) => {

      //console.log(data);

      user.is_worker = true;

      //this.okService.loadObjects();
      //this.getUsers();

      this.okService.setAlert(this.transloco.translate("The worker ")+user.name+this.transloco.translate(" has been added"),"success");

    });
  }

  doSearch(){
    //console.log(this.search);

    this.page = 1;

    let search = this.search;

    this.okService.get("geotab/users",{search:search})
    .subscribe((data) => {

      //console.log(data);

      this.users = data.body;


    });


  }
  cancelSearch(){
    //console.log(this.search);

    this.search="";

    this.getUsers();

  }

  prevPage(){

    if(this.page > 1){
      this.page = this.page - 1;
      this.getUsers();

    }
  }

  nextPage(){

    this.page = this.page + 1;
    this.getUsers();

  }

}
